import { useTheme } from "@mui/material";

export const useIsDarkMode = () => useTheme().palette.mode === "dark";

// TODO: create a hook to get the theme with light/dark custom palette
